import { Pipe, PipeTransform } from '@angular/core';

import { IArticle } from '../../prisma-xs/models/article.model';
import { ISearchOptionFlags, SearchOptionFlags } from '../../prisma-xs/models/prisma-xs.model';

@Pipe({
    name: 'searchArticle',
    standalone: false
})
export class SearchArticlePipe implements PipeTransform {

  transform(items: IArticle[], searchText: string): IArticle[] {
    if (!items || !searchText || !searchText.trim()) {
      return items;
    }

    const [ flag, searchValue ] = searchText.split(':');
    const flagSearch = this.checkIfIsFlagSearch(flag);
    const freeSearchFields = SearchOptionFlags.map(item => item.field);

    return items.filter(item => {
      if (flagSearch) {
        return this.searchComparator(item, flagSearch.field, searchValue);
      } else {
        for (const searchField of freeSearchFields) {
          const value = this.searchComparator(item, searchField, searchText);
          if (value) {
            return value;
          }
        }
      }
    });
  }

  private checkIfIsFlagSearch(flag: string): ISearchOptionFlags {
    return SearchOptionFlags.find(optionFlag => optionFlag.flag === `${flag}:`);
  }

  private searchComparator(item: IArticle, field: string, searchText: string): boolean {
    return item[field].toString().toLowerCase().includes(searchText?.trim().toLowerCase());
  }
}
